import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import First from '@/components/first'
import A from '@/components/A'
import B from '@/components/B'
import A1 from '@/components/A1'
import cusMain from '@/components/reportTools/cusMain'
import reportList from '@/components/reportTools/reportList'
import customQuery from '@/components/reportTools/customQuery'
import customQueryEdit from '@/components/reportTools/customQueryEdit'
import test2 from '@/components/reportTools/test2'
import test from '@/components/reportTools/test'
import  newReportList from '@/components/reportTools/newReportList'
//import guanfang from '@/components/reportTools/guanfang'
import previewReport from '@/components/reportTools/previewReport'
import dataSetMain from "../components/dataSource/dataSetMain"
import dataSourceMain from "../components/dataSource/dataSourceMain"
import reportToService from '@/components/reportTools/reportToService'
import basicMessageSet from '@/components/reportTools/basicMessageSet'
import basicMessageSetEdit from '@/components/reportTools/basicMessageSetEdit'
import defineDataSet from "../components/dataSource/defineDataSet";
import newdefineDataSettest from "../components/dataSource/newdefineDataSettest";
import addDataSetCol from "../components/dataSource/addDataSetCol";
import addDataSet from "../components/dataSource/addDataSet";
import demo from '@/components/reportTools/demo'



Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'First',
      component: First,
    },
    {
      path: '/a',
      component:A,
    },
    {
      path: '/b',
      component:B
    },
    {
      path: '/A1',
      component:A1,
      children:[
      ]
    },
    {
      path: '/reportTools/cusMain',
      component: cusMain
    },
    {
      path: '/reportTools/reportList',
      name: 'reportList',
      component: reportList
    },
    {
      path: '/reportTools/basicMessageSet',
      name: 'basicMessageSet',
      component: basicMessageSet
    },
    {
      path: '/reportTools/basicMessageSetEdit',
      name: 'basicMessageSetEdit',
      component: basicMessageSetEdit
    },
    {
      path: '/reportTools/customQuery',
      name:'customQuery',
      component: customQuery
    },{
      path: '/reportTools/customQueryEdit',
      name:'customQueryEdit',
      component: customQueryEdit
    },
    {
      path: '/reportTools/test',
      component: test
    },{
      path: '/reportTools/test2',
      component: test2
    },{
      path: '/reportTools/newReportList/:cusId/',
      name: 'newReportList',
      component: newReportList
    },{
      path: '/reportTools/previewReport',
      component: previewReport
    },{
      path: '/reportTools/reportToService',
      component: reportToService
    },{
      path: '/reportTools/demo',
      component: demo
    },
    {
      path:'/dataSetMain',
      name:'dataSetMain',
      component:dataSetMain
    },
    {
      path:'/dataSourceMain',
      name:'dataSourceMain',
      component: dataSourceMain,
      meta: {
        keepAlive: false // 不需要被缓存
      }
    },
    {
      path:'/defineDataSet',
      name:'defineDataSet',
      component: defineDataSet,
      meta:{
        keepAlive: true //需要被缓存
      }
    },
    {
      path:'/addDataSetCol',
      name:'addDataSetCol',
      component: addDataSetCol
    },
    {
      path:'/newdefineDataSettest',
      name:'newdefineDataSettest',
      component: newdefineDataSettest
    },
    {
      path: '/reportTools/cusMain',
      component: cusMain
    },
    {
      path: '/addDataSet',
      name: 'addDataSet',
      component: addDataSet
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js